import { Background, ReactFlow, type ReactFlowProps } from "@xyflow/react";
import type { ReactNode } from "react";
import "@xyflow/react/dist/style.css";

type CanvasProps = ReactFlowProps & {
  children?: ReactNode;
  /**
   * Whether dragging on the canvas pans the viewport. Defaults to `false`
   * so consumers get the lego-standard "selection on drag" behaviour out
   * of the box. Pass `true` to opt into the ReactFlow default (drag to
   * pan, no rubber-band selection).
   */
  panOnDrag?: boolean;
  /**
   * Whether dragging on the canvas draws a selection rectangle. Defaults
   * to `true` and is forwarded to the underlying ReactFlow instance.
   */
  selectionOnDrag?: boolean;
};

export const Canvas = ({
  children,
  panOnDrag = false,
  selectionOnDrag = true,
  ...props
}: CanvasProps) => (
  <ReactFlow
    deleteKeyCode={["Backspace", "Delete"]}
    fitView
    panOnDrag={panOnDrag}
    panOnScroll
    selectionOnDrag={selectionOnDrag}
    zoomOnDoubleClick={false}
    {...props}
  >
    <Background bgColor="var(--sidebar)" />
    {children}
  </ReactFlow>
);
